// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add global styles here */

.container {
  background-color: rgb(247, 248, 249);
  padding: 20px;
  display: flex;
  flex-direction: column;
  max-width: 85%;
  margin: 0;
  overflow: visible;
  margin-left: 200px;
}

.content-wrapper {
  display: flex;
  width: 100%;
}

/* Sidebar styles */
.sidebar {
  width: 30%;
  padding: 20px;
  background-color: #f0f0f0;
}

/* Main content styles */
.main-content {
  width: 70%;
  padding: 20px;
}

/* Style for the sidebar list items */
.sidebar mat-list-item {
  cursor: pointer;
}

/* Style for the main content list items */
.main-content mat-list-item {
  cursor: pointer;
}

.mat-list-base {
  padding-top: 0px !important;
}

.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px; /* Adjust the height as needed */
  background-color: #f5f5f5; /* Background color for the no-data container */
  margin: 20px 0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.no-data-message {
  font-size: 18px;
  color: #777;
  text-align: center;
  padding: 20px;
}

.question-item {
  position: relative;
  margin-bottom: 10px;
  cursor: pointer;
  padding: 10px;
  border: 1px solid #dcdcdc;
  background-color: #fdfdfd;
}


.mat-list-item {
  margin-bottom: 10px; /* Ensure spacing between items if .mat-list-item is used directly */
  border: 2px solid #ddd; /* Consistent with .answer-item styling if applicable */
  border-radius: 5px; /* Rounded corners for a consistent look */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Shadow for depth */
}

/* Add styles here */

.expand-icon {
  float: right;
  font-weight: bold;
}

.answer-box {
  padding: 10px;
  margin-bottom: 10px;
  margin-left: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  background-color: orange;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  -webkit-hyphens: auto;
          hyphens: auto;
}





`, "",{"version":3,"sources":["webpack://./src/app/faq-tab/faq-tab.component.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,gCAAgC;EAC/C,yBAAyB,EAAE,+CAA+C;EAC1E,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB,EAAE,oEAAoE;EACzF,sBAAsB,EAAE,uDAAuD;EAC/E,kBAAkB,EAAE,0CAA0C;EAC9D,wCAAwC,EAAE,qBAAqB;AACjE;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAa;UAAb,aAAa;AACf","sourcesContent":["/* Add global styles here */\n\n.container {\n  background-color: rgb(247, 248, 249);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  max-width: 85%;\n  margin: 0;\n  overflow: visible;\n  margin-left: 200px;\n}\n\n.content-wrapper {\n  display: flex;\n  width: 100%;\n}\n\n/* Sidebar styles */\n.sidebar {\n  width: 30%;\n  padding: 20px;\n  background-color: #f0f0f0;\n}\n\n/* Main content styles */\n.main-content {\n  width: 70%;\n  padding: 20px;\n}\n\n/* Style for the sidebar list items */\n.sidebar mat-list-item {\n  cursor: pointer;\n}\n\n/* Style for the main content list items */\n.main-content mat-list-item {\n  cursor: pointer;\n}\n\n.mat-list-base {\n  padding-top: 0px !important;\n}\n\n.no-data-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px; /* Adjust the height as needed */\n  background-color: #f5f5f5; /* Background color for the no-data container */\n  margin: 20px 0;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.no-data-message {\n  font-size: 18px;\n  color: #777;\n  text-align: center;\n  padding: 20px;\n}\n\n.question-item {\n  position: relative;\n  margin-bottom: 10px;\n  cursor: pointer;\n  padding: 10px;\n  border: 1px solid #dcdcdc;\n  background-color: #fdfdfd;\n}\n\n\n.mat-list-item {\n  margin-bottom: 10px; /* Ensure spacing between items if .mat-list-item is used directly */\n  border: 2px solid #ddd; /* Consistent with .answer-item styling if applicable */\n  border-radius: 5px; /* Rounded corners for a consistent look */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Shadow for depth */\n}\n\n/* Add styles here */\n\n.expand-icon {\n  float: right;\n  font-weight: bold;\n}\n\n.answer-box {\n  padding: 10px;\n  margin-bottom: 10px;\n  margin-left: 20px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  background-color: orange;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  hyphens: auto;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
